import { render, staticRenderFns } from "./SettlementsByPayeeTable.vue?vue&type=template&id=9c6e5aa2&scoped=true&"
import script from "./SettlementsByPayeeTable.vue?vue&type=script&lang=js&"
export * from "./SettlementsByPayeeTable.vue?vue&type=script&lang=js&"
import style0 from "./SettlementsByPayeeTable.vue?vue&type=style&index=0&id=9c6e5aa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c6e5aa2",
  null
  
)

export default component.exports